import React, { forwardRef } from "react";
import { StepRef, StepProps } from "../types";
import { Box, Button, Typography } from "@mui/material";
import StaticStep from "../components/StaticStep";
import { format } from "date-fns";
import useIsMobile from "components/hooks/useIsMobile";
import { useNavigate } from "react-router-dom";

export default forwardRef<StepRef, StepProps>(({ signupState }, _ref) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <StaticStep
      title="You're booked!"
      img="/assets/images/nux/life-changing.png"
      mobileImg="/assets/images/nux/life-changing-mobile.png"
      bodyContent={
        <>
          <Box>
            {signupState.consultation?.eventDate && (
              <Typography variant="h4">
                {format(
                  signupState.consultation.eventDate,
                  "EEEE, MMMM d 'at' h:mm a",
                )}
              </Typography>
            )}
          </Box>
          <Box>
            We'll send a confirmation to your email and call you at the
            scheduled time.
          </Box>

          <Box sx={{ marginTop: isMobile ? "20px" : "32px" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/")}
              sx={{
                bgcolor: "#198282",
                "&:hover": {
                  bgcolor: "#276767",
                },
                borderRadius: "32px",
                textTransform: "none",
                width: isMobile ? "100%" : "auto",
              }}
            >
              Back to Home
            </Button>
          </Box>
        </>
      }
    />
  );
});
